import { FORM_TYPES } from '../../../types/paramsConfig.js';
import AccountIdentifier from '../../../views/AccountIdentifier/index.js';
import TwoStepLogin from '../../../views/TwoStepLogin/index.js';
import TwoStepRegistration from '../../../views/TwoStepRegistration/index.js';
import TwoStepResetPassword from '../../../views/TwoStepResetPassword/index.js';
import TwoStepResetPasswordSuccess from '../../../views/TwoStepResetPasswordSuccess/index.js';
import AppleUpdateEmail from '../../../views/AppleUpdateEmail/index.js';
import { CVUploadModal } from '../../features/registrationSuccess/RegistrationSuccessModal/CVUploadModal.js';
import TwoStepPasswordlessConfirmation from '../../../views/TwoStepPasswordlessConfirmation/index.js';
import TwoStepReturning from '../../../views/TwoStepReturning/index.js';
export const stepModalFormConfigs = () => {
    return [
        {
            component: AccountIdentifier,
            type: FORM_TYPES.TWO_STEP_ACCOUNT_IDENTIFIER,
        },
        {
            component: TwoStepReturning,
            type: FORM_TYPES.TWO_STEP_RETURNING,
        },
        {
            component: TwoStepLogin,
            type: FORM_TYPES.TWO_STEP_LOGIN,
        },
        {
            component: TwoStepRegistration,
            type: FORM_TYPES.TWO_STEP_REGISTRATION,
        },
        {
            component: TwoStepResetPassword,
            type: FORM_TYPES.TWO_STEP_RESET_PASSWORD,
        },
        {
            component: TwoStepResetPasswordSuccess,
            type: FORM_TYPES.TWO_STEP_RESET_PASSWORD_SUCCESS,
        },
        {
            component: CVUploadModal,
            type: FORM_TYPES.TWO_STEP_CV_UPLOAD,
        },
        {
            component: AppleUpdateEmail,
            type: FORM_TYPES.TWO_STEP_APPLE_UPDATE_EMAIL,
        },
        {
            component: TwoStepPasswordlessConfirmation,
            type: FORM_TYPES.TWO_STEP_PASSWORDLESS_CONFIRMATION,
        },
    ];
};
//# sourceMappingURL=stepModalFormConfigs.js.map